import React, {useState,useEffect,Fragment} from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import '../main.css'
import Layout from 'components/sales/layout/layout';
import SiteInformationForm from 'components/fileComplain/formSection/siteInformationForm/valetFilter';
import CustomModal from "../modal";

const Valet = ({
    valetList,
    supervisorRes,
    siteInfo = [],
    updateValetStatus,
    updateValetStatusDetails = {}
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [projectId, setProjectId] = useState("");
    const [count, setCount] = useState(0)
    const [notify, setNotify] = useState("");

    useEffect(() => {
       
        const tableData = ['id', 'name', 'phone_number', 'active'];
        if(siteInfo && siteInfo.length > 0){
            const data = siteInfo.map((element) =>{
                console.log(element);
                Object.assign(
                          {},
                          ...tableData.map((key) => ({ [key]: element[key] })),
                          
                        )
            });
            console.log(data);
            if (data) {
                setListData(data);
                }
                

        }
      }, [siteInfo]);

      
      const headerBtns = () => {
        return (
            <>
            <Fragment>
                <a
                href={`/dashboard/valet`}
                className="btn btn-primary d-none d-md-inline-block"
                
                >Add Valet</a>
            </Fragment>
            </>
        );
      };

    const handleDisable = async (id, userId) => {
        let data = {
            'project_id': projectId,
            'user_id':userId,
        }

        setIsLoading(true)
        let res = await updateValetStatus(data)
        setNotify(res.data.response.status)
        setIsLoading(false)
        setCount(count+1)
    }

    return (
        
          <Layout title={localization.valetList} 
            Buttons={headerBtns}
            isLoading={isLoading}>
                <div className="row">
                    <div className="col-md-12">
                    <PanelCardWithHeading
                        title={localization.Filter}
                        
                        isLoading={isLoading}
                            >
                            <SiteInformationForm
                            
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            
                            siteInformationData={async (val) => {
                                setProjectId(val?.projectId)
                                setIsLoading(true);
                                await valetList(val);
                                setIsLoading(false);
                            }}
                            />
                    </PanelCardWithHeading>
                    </div>
                    <div className="col-md-12">
                
            
           
                {siteInfo && siteInfo.length > 0 && (
                    <PanelCardWithHeading title={localization.valetList}>
                        {updateValetStatusDetails !== {} && notify !== 200 &&
                            <CustomModal msg={updateValetStatusDetails?.response?.message} click={count}/>}
                        {updateValetStatusDetails !== {} && notify === 200 &&
                            <CustomModal msg={updateValetStatusDetails?.response?.message} isPageLoad={true}  click={count}/>}
                        <table className="panel-table table table-bordered">
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Id</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Contact</th>
                                    <th>Valet Type</th>
                                    <th>Active</th>
                                    <th>Date</th>
                                    <th style={{"text-align":"left"}}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {siteInfo && siteInfo.length > 0 ?
                                    <>
                                    {siteInfo.map((val,key) => {
                                        
                                        return(<tr key={{key}}>
                                            <td>{key+1}</td>
                                            <td>{val.id}</td>
                                            <td>{val.first_name}</td>
                                            <td>{val.last_name}</td>
                                            <td>{val.phone_number}</td>
                                            <td>{val.valet_type}</td>
                                            <td>{val.active ?'Yes' :'No'}</td>
                                            <td>{val.created_at && val.created_at.slice(0,10)}</td>
                                            <td>
                                                <center>
                                                    <button className="btn btn-sm btn-primary"
                                                            onClick={() => {handleDisable(val.id, val.user_id)}}>{val.active ? 'Disable' : 'Enable'}</button>
                                                </center>
                                            </td>
                                        </tr>);
                                    })}
                                    
                                    </>
                                   
                                : null}
                            </tbody>
                        </table>
                    {/* <TableSection
                        data={[]}
                        // isId={false}
                        headers={headers}
                        // detailList={siteInfo}
                    /> */}
                    </PanelCardWithHeading>
                )}
                </div>
                </div>
                
            
            </Layout>
        
    );
};

export default Valet
